export default __webpack_public_path__ + "static/media/todo.493e275a.png";